import { Component, ChangeDetectorRef, HostListener } from '@angular/core';
import { AdministratorModeActions } from './core/_store/actions';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as fromStore from "./core/_store";
import { AuthService } from './core/services/auth/auth.service';
import { GlobalEventDistributor } from 'src/globalEventDistributor';
import { Router } from '@angular/router';
import * as singleSpa from 'single-spa';
import { AlertifyService } from 'jul-web-shared-lib/src/lib/components/alertify';
import { RoutingStateService } from './core/services/routing-state/routing-state.service';
import { HttpClient } from '@angular/common/http';
import { JulContextLibService } from 'jul-web-shared-lib/src/lib/components/context';
import { ApiEndpoints } from './core/http/api-endpoints';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'jul-web-core-new';
  isAdminSubscription$: Subscription;
  isAdmin: boolean = false;
  sideMenuItems: any;
  top = "0px";
  subscrition$: Subscription;
  alertsLength: number = 0;
  loadContextTimezones = false;
  loadAlerts = false;
  constructor(
    private store: Store<fromStore.CoreState>,
    private cdr: ChangeDetectorRef,
    private route: Router,
    private http: HttpClient,
    private julContextService: JulContextLibService,
    private alertifyService: AlertifyService,
    private routingStateService: RoutingStateService, // DO NOT DELETE (Routing State Initializer)
    public authService: AuthService,
    private router: Router,
    private globalEventDistributor: GlobalEventDistributor,
    private translate: TranslateService,
  ) {
    this.globalEventDistributor.subscriber.subscribe((action: any) => {
      if (action && action.type == "AUTHORIZED") {
        this.authService.currentUser = action.payload;
        this.cdr.detectChanges();
      }

    });

    router.events.subscribe(event => {
      // The shell (this component) is not destroyed on logout and the login
      // redirect only changes the URL hash, so in-memory state survives across
      // sessions in the same tab. When there is no session, reset everything
      // that was loaded for the previous user so the next login does not see
      // the previous user's alerts and does fetch its own.
      if (!localStorage.getItem('user')) {
        if (this.loadAlerts) {
          this.loadAlerts = false;
          this.alertifyService.clear();
        }
        this.loadContextTimezones = false;
      }
      if (!this.loadContextTimezones && localStorage.getItem('user') && !localStorage.getItem('context-timezone')){
        this.loadContextTimezones = true;
        this.julContextService.setContextWithAuthorityPortuary();
        this.http.get(ApiEndpoints.master_data.timezone.get()).subscribe((resp: any) => {
          localStorage.setItem('context-timezone', JSON.stringify(resp));
        })
      }
      if(!this.loadAlerts && localStorage.getItem('user') && !localStorage.getItem('login-alerts')){
        this.loadAlerts = true;
        this.http.get(ApiEndpoints.gad.user_token.getAlerts()).subscribe((resp:any) => {
          if(resp && resp.alerts && resp.alerts.length > 0){
            localStorage.setItem('login-alerts', JSON.stringify(resp.alerts));

            resp.alerts.map(alert => (alert.level === 'WARNING') ? this.alertifyService.warning(alert.message) : null);
          }
        })
      }
    });
  }



  get islogin(){
    return singleSpa.getAppStatus('jul-web-login') == 'MOUNTED';
  }

  ngOnInit() {

    this.isAdminSubscription$ = this.store.pipe(select(fromStore.getSelectedIsAdmin))
    .subscribe(data => {
      let administrationHeader: string = '0px';
      if (data != undefined) {
        data ? administrationHeader = '30px' : administrationHeader = '0px';
        this.isAdmin = data;
        document.body.style.setProperty('--administrationHeader', administrationHeader);
      } else {
        let isAdmin: boolean = false;
        if(localStorage.getItem("isAdmin")) {
          isAdmin = true;
          administrationHeader = '30px'
        } else {
          isAdmin = false;
          administrationHeader = '0px'
        }
        this.isAdmin = isAdmin;
        document.body.style.setProperty('--administrationHeader', administrationHeader);
      }
    });

  }

  updateAlerts(alerts){
    this.alertsLength = alerts.length;
    this.recomputeAlertOffset();
  }

  @HostListener('window:resize')
  onResize() {
    // The banner can wrap to a different height when the viewport changes.
    this.recomputeAlertOffset();
  }

  // Measure the rendered banner height and expose it as a CSS variable so the
  // fixed header (top) and the page content (.main padding-top) stay aligned
  // with the fixed alert banner. Deferred so the measurement runs after the
  // alert is rendered.
  private recomputeAlertOffset() {
    setTimeout(() => {
      const container = document.querySelector('.alert-wrapper .alerts-container') as HTMLElement;
      const height = (this.alertsLength > 0 && container) ? container.offsetHeight : 0;
      document.body.style.setProperty('--alertHeader', height + 'px');
    });
  }

  exitAdministratorMode() {
    this.store.dispatch(new AdministratorModeActions.LoadMenuRegular());
  }
}
